import { useInfiniteQuery } from 'react-query';
import {
  getAdaptedFictionPreviews,
  type AdaptedFictionPreviewResponse
} from '../../services/sceneService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export const useGetAdaptedFictionPreviews = ({
  perPage,
  castRelationshipId,
  enabled = true
}: {
  perPage: number;
  castRelationshipId: string;
  enabled?: boolean;
}) => {
  return useInfiniteQuery<AdaptedFictionPreviewResponse, Error>(
    [...SCENE_QUERY_KEYS.adaptedFictionPreviews, castRelationshipId, perPage],
    ({ pageParam = 1 }) =>
      getAdaptedFictionPreviews({ page: pageParam, perPage, castRelationshipId }),
    {
      enabled: enabled && Boolean(castRelationshipId),
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage) return undefined;
        if (lastPage.length < perPage) return undefined;
        return allPages.length + 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 1000 * 60 * 5
    }
  );
};
